/// <amd-module name="Build/ArtifactsView/Components/ArtifactsHeaderBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class ArtifactsHeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {

    public getBreadcrumbItems(): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setBreadcrumbs(pipelineName: string, pipelineUrl: string, runNumber: string, runUrl: string, artifactTabName?: string, artifactTabUrl?: string, imageName?: string, imageUrl?: string): void {
        this.items.removeAll();

        this.items.push({
            key: "pipeline-breadcrumb",
            text: pipelineName,
            href: pipelineUrl,
            onClick: (ev) => {
                onClickFPS(this.pageContext, pipelineUrl, true, ev, { telemetrySource: "pipeline-breadcrumb" });
            }
        });

        this.items.push({
            key: "run-breadcrumb",
            text: runNumber,
            href: runUrl,
            onClick: (ev) => {
                onClickFPS(this.pageContext, runUrl, true, ev, { telemetrySource: "run-breadcrumb" });
            }
        });

        if (artifactTabName && artifactTabUrl) {
            this.items.push({
                key: "artifact-tab-breadcrumb",
                text: artifactTabName,
                href: artifactTabUrl,
                onClick: (ev) => {
                    onClickFPS(this.pageContext, artifactTabUrl, true, ev, { telemetrySource: "artifact-tab-breadcrumb" });
                }
            });
        }

        if (imageName && imageUrl) {
            this.items.push({
                key: "container-image-view-details-breadcrumb",
                text: imageName,
                href: imageUrl,
                onClick: (ev) => {
                    onClickFPS(this.pageContext, imageUrl, true, ev, { telemetrySource: "container-image-view-details-breadcrumb" });
                }
            });
        }
    }

    public clearBreadcrumbs(): void {
        this.items.removeAll();
    }

    private items = new ObservableArray<IBreadcrumbItem>();
}

Services.add("artifacts-header-breadcrumb-service", { serviceFactory: ArtifactsHeaderBreadcrumbService });
